import slide1 from "./../styles/images/slide1.png";
import slide2 from "./../styles/images/slide2.png";
import slider001 from "./../styles/images/slider001.png";
import slider002 from "./../styles/images/slider002.png";
import slider003 from "./../styles/images/slider003.png";
import slider004 from "./../styles/images/slider004.png";
import slider005 from "./../styles/images/slider005.png";
import slider006 from "./../styles/images/slider006.png";
import slider007 from "./../styles/images/slider007.png";
import slider008 from "./../styles/images/slider008.png";

const mains = [
  {
    title: "Проект Avto-Sphere",
    img: slide1,
    skills: "проект на php и js",
    link: "https://www.avto-sphere.ru",
  },
  {
    title: "Проект GreatWallZap",
    img: slide2,
    skills: "проект на php и js",
    link: "https://www.greatwallzap.ru",
  },
  {
    title: "Заметки",
    img: slider005,
    skills: "чат на react.js",
    link: "https://aharenkon.github.io/crud/",
  },
  {
    title: "Filter-ex",
    img: slider001,
    skills: "проект на react.js",
    link: "https://pevec1.github.io/filter-ex/",
  },
  {
    title: "Use-effect",
    img: slider007,
    skills: "проект на react.js",
    link: "https://pevec1.github.io/use-effect/",
  },
  {
    title: "Мировые часы",
    img: slider002,
    skills: "проект на react.js",
    link: "https://axawatches.netlify.app/",
  },
  {
    title: "Calendar-vite",
    img: slider003,
    skills: "проект на react.js",
    link: "https://axacalend.netlify.app/",
  },
  {
    title: "To card, To list",
    img: slider004,
    skills: "проект на react.js",
    link: "https://pevec1.github.io/layouts/",
  },
  {
    title: "JsonFetchHook",
    img: slider008,
    skills: "проект на react.js",
    link: "https://pevec1.github.io/useJsonFetch/",
  },
  {
    title: "Задачи js+php",
    img: slider006,
    skills: "",
    link: "https://zadachi.good-cms.ru/",
  },
];

export { mains };
